<template>
  <article class="portal-app-card">
    <div class="portal-app-card__title">
      <img
        v-if="showBundledLogo && bundledLogoSrc"
        :src="bundledLogoSrc"
        alt=""
        class="portal-app-card__logo"
      />
      <span v-else-if="showBundledLogo" class="portal-app-card__name">{{
        app.name
      }}</span>
      <img
        v-else-if="showCustomLogo"
        :src="app.logo"
        alt=""
        class="portal-app-card__logo"
      />
      <span v-else class="portal-app-card__name">{{ app.name }}</span>
    </div>

    <span class="portal-app-card__divider" aria-hidden="true" />

    <div
      class="portal-app-card__description"
      v-html="descriptionHtml"
    />

    <footer class="portal-app-card__footer">
      <button
        v-if="app.status_for_user == 0"
        type="button"
        class="portal-app-card__cta portal-app-card__cta--request"
        @click="$emit('request-access', app.id)"
      >
        {{ $t("myApps.buttons.requestAccess") }}
      </button>
      <button
        v-else-if="app.status_for_user == 1"
        type="button"
        class="portal-app-card__cta portal-app-card__cta--pending"
        disabled
      >
        {{ $t("myApps.buttons.pending") }}
      </button>
      <button
        v-else-if="app.status_for_user == 2"
        type="button"
        class="portal-app-card__cta portal-app-card__cta--open"
        @click="openUrl(app.url)"
      >
        {{ $t("myApps.buttons.open") }}
      </button>
    </footer>
  </article>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";
import { useStore } from "vuex";

import { getPortalAppLogoSrc } from "@/components/PortalHome/portalAppAssets.js";

const props = defineProps({
  app: { type: Object, required: true },
});

defineEmits(["request-access"]);

const store = useStore();
const currentLocale = computed(() => store.getters.getCurrentLocale);

const showBundledLogo = computed(
  () => props.app.logo === "1" || props.app.logo === 1
);
const showCustomLogo = computed(
  () =>
    props.app.logo &&
    props.app.logo !== "0" &&
    props.app.logo !== 0 &&
    props.app.logo !== "1" &&
    props.app.logo !== 1
);

const bundledLogoSrc = computed(() =>
  getPortalAppLogoSrc(props.app.code_name)
);

const descriptionHtml = computed(() => {
  const { has_translations, translated_data, description } = props.app;
  if (has_translations && translated_data) {
    return (
      translated_data[currentLocale.value] ||
      description ||
      "-"
    );
  }
  return description || "-";
});

function openUrl(url) {
  if (url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/portal-app-card";
</style>
